module.exports = __webpack_public_path__ + "static/body-background-1b0ae89eee377706e2e06af91051845c.jpg";